import { Box, Space } from '@looker/components';

import { useCurrentAsset } from '@/hooks/use-current-asset';

import type { Filters } from '../entities/filters';

import { ChartTypesFilter } from './chart-types-filter';
import { DateRangeFilter } from './date-range-filter';
import { NoiseFilter } from './noise-filter';
import { TopFilter } from './top-filter';
import { UnitsFilter } from './units-filter';

export type DataExplorerFiltersProps = {
  value: Filters;
  onChange: (filters: Partial<Filters>) => void;
  onlyTop?: boolean;
};

export function DataExplorerFilters({
  onlyTop,
  value: filters,
  onChange,
}: DataExplorerFiltersProps) {
  const { isMobility } = useCurrentAsset();

  return (
    <Box className="filters-wrapper">
      <Space className="filters" align="start" between>
        <Space align="start" flexWrap="wrap">
          {!isMobility ? (
            <TopFilter
              value={filters.top}
              onChange={(top) => onChange({ top, units: undefined })}
            />
          ) : null}
          <UnitsFilter
            hide={onlyTop}
            top={filters.top}
            value={filters.units ?? []}
            onChange={(units) => onChange({ units, deviceId: undefined })}
            deviceId={filters.deviceId}
          />
          <ChartTypesFilter
            value={filters.chartTypes}
            onChange={(chartTypes) => onChange({ chartTypes })}
          />
          <DateRangeFilter
            value={{ from: filters.from, to: filters.to }}
            onChange={({ from, to }) => onChange({ from, to })}
          />
          <NoiseFilter
            value={filters.filterNoise}
            onChange={(filterNoise) =>
              onChange({ filterNoise: filterNoise ? undefined : false })
            }
          />
        </Space>
      </Space>
    </Box>
  );
}
